import { Button, Text } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import React from "react";

import { ReactComponent as NoDataImage } from "img/icons/status/noData.svg";
import { ReactComponent as NoDataPlusBtn } from "img/icons/status/noDataPlus.svg";
import "./noDataMessage.scss";

const NoDataMessage = (props) => {
  const { t } = useTranslation();
  const {
    title = t("noDataMessage.nothingToShowHere"),
    description = "",
    buttonText = "",
    onClick = () => {},
    style,
    Image = NoDataImage,
    centerDescription = false,
    centerTitle = false,
  } = props;

  return (
    <div className='noDataMessageWrap' style={style}>
      <div style={{ display: 'flex', alignItems: 'center', position: 'relative', zIndex: 1 }}>
        <Image />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-extra-tight)'}}>
          {centerTitle ? (
            <div style={{ textAlign: 'center' }}>
              <Text color='subdued' fontWeight='medium'>{title}</Text>
            </div>
          ) : (
            <Text color='subdued' fontWeight='medium'>{title}</Text>
          )}
          {description && (
            <div style={centerDescription ? { textAlign: 'center' } : undefined}>
              {description.split(/\n/).filter(Boolean).map((line, i) => (
                <Text key={i} color='subdued' as='p' style={{ margin: i > 0 ? '0.25em 0 0' : 0 }}>
                  {line}
                </Text>
              ))}
            </div>
          )}
          {buttonText && (
            <Button
              variant={'plain'}
              icon={<NoDataPlusBtn style={{ marginTop: "4px" }} />}
              onClick={onClick}
            >
              {buttonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

NoDataMessage.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  Image: PropTypes.elementType,
  style: PropTypes.object,
  centerDescription: PropTypes.bool,
  centerTitle: PropTypes.bool,
};

export default NoDataMessage;
